// import React from 'react';
// import { alpha } from '@mui/material/styles';
// import Menu from '@mui/material/Menu';
// import { styled } from '@mui/system';

// const StyledMenu = styled((props) => (
//   <Menu
//     elevation={0}
//     anchorOrigin={{
//       vertical: 'bottom',
//       horizontal: 'right',
//     }}
//     transformOrigin={{
//       vertical: 'top',
//       horizontal: 'right',
//     }}
//     {...props}
//   />
// ))(({ theme }) => ({
//   '& .MuiPaper-root': {
//     borderRadius: 6,
//     marginTop: theme.spacing(1),
//     minWidth: 180,
//     color:
//       theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
//     boxShadow:
//       'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
//     '& .MuiMenu-list': {
//       padding: '4px 0',
//     },
//     '& .MuiMenuItem-root': {
//       '& .MuiSvgIcon-root': {
//         fontSize: 18,
//         color: "#000",
//         marginRight: theme.spacing(1.5),
//       },
//       '&:active': {
//         backgroundColor: "white",
//       },
//     },
//   },
// }));

// export default StyledMenu;


import React from 'react';
import Menu from '@mui/material/Menu';
import { styled } from '@mui/system';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 12,
    marginTop: theme.spacing(1),
    minWidth: 220,
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    boxShadow:
      '0px 4px 6px -2px rgba(0, 104, 255, 0.06), 0px 10px 25px -3px rgba(0, 104, 255, 0.12), 0px 0px 0px 1px rgba(0, 104, 255, 0.08)',
    '& .MuiMenu-list': {
      padding: '6px 0',
    },
    '& .MuiMenuItem-root': {
      fontSize: 15,
      fontWeight: 300,
      padding: '12px 20px',
      color: '#1a1a1a',
      transition: 'background-color 0.2s ease, color 0.2s ease',

      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: '#0068FF',
        marginRight: theme.spacing(1.5),
      },

      // Active/selected state
      '&.Mui-selected': {
        color: '#0068FF',
        backgroundColor: 'rgba(0, 104, 255, 0.06)',
        fontWeight: 500,
        '&:hover': {
          backgroundColor: 'rgba(0, 104, 255, 0.10)',
        },
      },

      // Hover state
      '&:hover': {
        backgroundColor: 'rgba(0, 104, 255, 0.06)',
        color: '#0068FF',
      },

      // Active click state
      '&:active': {
        backgroundColor: 'rgba(0, 104, 255, 0.12)',
        color: '#0068FF',
      },

      // Divider between items
      '&:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 104, 255, 0.08)',
      },
    },
  },
}));

export default StyledMenu;
